import Glide from "@glidejs/glide";

const productCardSliderHandler = () => {
	const productSliders = document.querySelectorAll(".product-card-row__glide--mobile");

	productSliders.forEach((slider, i) => {
		const autoplay = slider.dataset.autoplay;
		// Check if the slider has already been initialized
		if (!slider.hasAttribute("data-initialized")) {
			new Glide(slider, {
				type: "carousel",
				startAt: 0,
				perView: 1,
				autoplay: Number(autoplay),
				gap: 20,
			}).mount();
			// Mark the slider as initialized
			slider.setAttribute("data-initialized", "true");
		}
	});

	const productDesktopSliders = document.querySelectorAll(
		".product-card-row__glide--desktop",
	);

	if (productDesktopSliders.length) {
		productDesktopSliders.forEach((slider, i) => {
			const gap = slider.dataset.gap;
			const autoplay = slider.dataset.autoplay;
			// Check if the slider has already been initialized
			if (!slider.hasAttribute("data-initialized")) {
				new Glide(slider, {
					type: "carousel",
					focusAt: 0,
					perView: 3,
					autoplay: Number(autoplay),
					gap: Number(gap),
					breakpoints: {
						1024: { perView: 2 },
					},
				}).mount();

				// Mark the slider as initialized
				slider.setAttribute("data-initialized", "true");
			}
		});
	}
};

if (document.readyState !== "loading") {
	productCardSliderHandler();
} else {
	document.addEventListener("DOMContentLoaded", productCardSliderHandler);
}

// cart logic

// document.addEventListener("DOMContentLoaded", () => {
// 	const updateCart = async (value, product, stockQuantity, backorders) => {
// 		const input = product.querySelector(".quantity-input");
// 		const productId = product.dataset.productId;
// 		const actionButtons = product.querySelectorAll(".quantity-action-button");
// 		let quantity = parseInt(value);

// 		// Disable buttons and add loading state
// 		actionButtons.forEach((button) => (button.disabled = true));
// 		product.classList.add("loading");

// 		// Check for backorder notify status
// 		if (quantity >= stockQuantity && backorders === "no") {
// 			product.classList.add("maximum-available-product");
// 		} else {
// 			product.classList.remove("maximum-available-product");
// 		}

// 		// Add "on-backorder-product" class if backorders is "notify" and quantity exceeds stock
// 		if (backorders === "notify") {
// 			product.classList.add("on-backorder-product");
// 			const backorderAmount = product.querySelector(".backorder-amount");
// 			if (backorderAmount && quantity > stockQuantity) {
// 				backorderAmount.innerHTML = Math.abs(quantity - stockQuantity);
// 			} else {
// 				backorderAmount.innerHTML = 0;
// 				product.classList.remove("on-backorder-product");
// 			}
// 		} else {
// 			product.classList.remove("on-backorder-product");
// 		}

// 		if (quantity > 0) {
// 			product.classList.add("product-in-cart");
// 			try {
// 				const response = await makeRequest(
// 					wc_add_to_cart_params.ajax_url,
// 					"POST",
// 					{
// 						action: "update_cart",
// 						product_id: productId,
// 						quantity: quantity,
// 					},
// 				);

// 				if (response.success) {
// 					input.value = quantity;
// 					if (quantity === 0) {
// 						product.classList.remove("product-in-cart");
// 					}
// 				}
// 			} catch (error) {
// 				console.error("Error updating cart:", error);
// 			} finally {
// 				// Re-enable buttons and remove loading state
// 				actionButtons.forEach((actionButton) => {
// 					const isIncrease = actionButton.dataset.setQuantity === "increase";
// 					const isDecrease = actionButton.dataset.setQuantity === "decrease";
// 					// Disable decrease button if quantity is 1
// 					if (Number(input.value) <= 1) {
// 						if (isDecrease) {
// 							actionButton.disabled = true;
// 							actionButton.classList.add("disable-decrease");
// 						}
// 					} else {
// 						if (isDecrease) {
// 							actionButton.disabled = false;
// 							actionButton.classList.remove("disable-decrease");
// 						}
// 					}

// 					// Disable increase button if quantity equals stock and backorders are not allowed
// 					if (Number(input.value) === stockQuantity && backorders === "no") {
// 						if (isIncrease) {
// 							actionButton.disabled = true;
// 							actionButton.classList.add("disable-increase");
// 						}
// 					} else {
// 						if (isIncrease) {
// 							actionButton.disabled = false;
// 							actionButton.classList.remove("disable-increase");
// 						}
// 					}
// 				});
// 				product.classList.remove("loading");
// 			}
// 		} else {
// 			product.classList.remove("product-in-cart");
// 			await removeFromCart(product);
// 		}

// 		product.classList.remove("loading");
// 	};

// 	const removeFromCart = async (product) => {
// 		const increaseButton = product.querySelector(
// 			"[data-set-quantity='increase']",
// 		);
// 		const decreaseButton = product.querySelector(
// 			"[data-set-quantity='decrease']",
// 		);

// 		const productId = product.dataset.productId;

// 		// remove backorder classes
// 		product.classList.remove("on-backorder-product");
// 		const backorderAmount = product.querySelector(".backorder-amount");

// 		if (backorderAmount) {
// 			backorderAmount.innerHTML = 0;
// 		}

// 		// remove out of stock classes
// 		if (!product.classList.contains("out-of-stock-product")) {
// 			increaseButton.classList.remove("disable-increase");
// 			increaseButton.disabled = false;
// 		}

// 		// disable decrease button
// 		decreaseButton.classList.add("disable-decrease");
// 		decreaseButton.disabled = true;

// 		try {
// 			const response = await makeRequest(
// 				wc_add_to_cart_params.ajax_url,
// 				"POST",
// 				{
// 					action: "remove_from_cart",
// 					product_id: productId,
// 				},
// 			);

// 			if (response.success) {
// 				product.classList.remove("product-in-cart");
// 				product.querySelector(".quantity-input").value = 0;
// 			}
// 		} catch (error) {
// 			console.error("Error removing from cart:", error);
// 		}
// 	};

// 	const checkInputsOnLoad = () => {
// 		const products = document.querySelectorAll(".product-card-row__card");

// 		products.forEach((product) => {
// 			const stockQuantity = parseInt(product.dataset.stockQuantity, 10);
// 			const backorders = product.dataset.backorders;
// 			const quantityInput = product.querySelector(".quantity-input");

// 			if (quantityInput) {
// 				let quantity = parseInt(quantityInput.value) || 0;

// 				// Ensure quantity doesn't exceed stock and backorders are handled
// 				if (quantity > stockQuantity && backorders === "no") {
// 					quantity = stockQuantity;
// 				}

// 				// Remove product from cart if stock is 0 and backorders are not allowed
// 				if (stockQuantity === 0 && backorders === "no") {
// 					removeFromCart(product);
// 				} else if (quantity > 0) {
// 					updateCart(quantity, product, stockQuantity, backorders);
// 				}
// 			}
// 		});
// 	};

// 	async function makeRequest(url, method, data) {
// 		const formData = new URLSearchParams(data);
// 		const response = await fetch(url, {
// 			method: method,
// 			headers: {
// 				"Content-Type": "application/x-www-form-urlencoded",
// 			},
// 			body: formData,
// 		});

// 		return response.json();
// 	}

// 	// Initialize page load logic
// 	checkInputsOnLoad();

// 	const products = document?.querySelectorAll(".product-card-row__card");

// 	products?.forEach((product) => {
// 		const stockQuantity = parseInt(product.dataset.stockQuantity, 10);
// 		const backorders = product.dataset.backorders;
// 		const productId = product.dataset.productId;
// 		const quantityInput = product.querySelector(".quantity-input");
// 		const quantityActionButton = product.querySelectorAll(
// 			".quantity-action-button",
// 		);
// 		const addToCartButton = product.querySelector(".add-to-cart-button");
// 		const removeFromCartButton = product.querySelector(
// 			".remove-from-cart-button",
// 		);

// 		removeFromCartButton?.addEventListener("click", () => {
// 			removeFromCart(product);
// 		});

// 		quantityActionButton?.forEach((actionButton) => {
// 			actionButton?.addEventListener("click", () => {
// 				const isIncrease = actionButton.dataset.setQuantity === "increase";
// 				const currentQuantity = Number(quantityInput.value);

// 				// Check if we should apply stock restrictions
// 				const applyStockRestrictions =
// 					!isNaN(stockQuantity) && backorders === "no";

// 				if (isIncrease) {
// 					if (!applyStockRestrictions || currentQuantity < stockQuantity) {
// 						quantityInput.value = currentQuantity + 1;
// 					}
// 				} else {
// 					if (currentQuantity > 1) {
// 						quantityInput.value = currentQuantity - 1;
// 					}
// 				}

// 				updateCart(quantityInput.value, product, stockQuantity, backorders);
// 			});
// 		});

// 		// allows you to delete characters in input without removing items from cart until focus out
// 		quantityInput?.addEventListener("focusout", (e) => {
// 			if (e.target.value === "" || Number(e.target.value) === 0) {
// 				console.log(e.target.value)
// 				updateCart(0, product, stockQuantity, backorders);
// 			}
// 		});
		
// 		// updates cart with value in input
// 		quantityInput?.addEventListener("input", (e) => {
// 			e.target.value = e.target.value.replace(/[^0-9]/g, "");
// 			let quantity = Math.max(0, parseInt(e.target.value) || 0);

// 			if (e.target.value > stockQuantity && backorders === "no") {
// 				e.target.value = stockQuantity;
// 				quantity = stockQuantity;
// 			}

// 			if (quantity) {
// 				updateCart(quantity, product, stockQuantity, backorders);
// 			}
// 		});

// 		addToCartButton?.addEventListener("click", async () => {
// 			try {
// 				addToCartButton.textContent = "Adding...";
// 				const response = await makeRequest(
// 					wc_add_to_cart_params.ajax_url,
// 					"POST",
// 					{
// 						action: "update_cart",
// 						product_id: productId,
// 						quantity: 1,
// 					},
// 				);

// 				if (response.success) {
// 					updateCart(1, product, stockQuantity, backorders);
// 				}
// 			} catch (error) {
// 				console.error("Error adding to cart:", error);
// 			} finally {
// 				addToCartButton.textContent = "Add to Cart";
// 			}
// 		});
// 	});
// });

